import React from "react";
import { connect } from "react-redux";
import TablaRoles from "./rolesTable";
import ModalFuncionalidades from "./modalFuncionalidades";
import { doGetAllFunctionalities } from "./actions";
import listaFuncionalidades from "../../../../../helpers/rolAccess";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class Roles extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      selectedRowId: null,
      funcionalidades: [],
      isNewRow: false,
    };

    this.props.dispatch(doGetAllFunctionalities());
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  getListaFunctionalities = () => {
    const listaConIds = [];
    if (this.props.functionalities.length) {
      listaFuncionalidades.forEach((func) => {
        const dbFunc = this.props.functionalities.find((f) => f.Code.trim() === func.Code);
        let parent;
        if (func.parentCode) {
          parent = this.props.functionalities.find((f) => f.Code.trim() === func.parentCode);
        }
        if (dbFunc) {
          if (parent) {
            listaConIds.push({ ...func, Id: dbFunc.Id, parentId: parent.Id });
          } else {
            listaConIds.push({ ...func, Id: dbFunc.Id });
          }
        }
      });
    }

    return listaConIds;
  }

  handleModal = (isNewRow, selectedRowId) => {
    this.setState((prevState) => ({ showModal: !prevState.showModal, isNewRow, selectedRowId }));
  }


  render() {
    return (
      <div className="col-12 zero">
        <ModalFuncionalidades
          open={this.state.showModal}
          isNewRow={this.state.isNewRow}
          selectedRowId={this.state.selectedRowId}
          onClose={this.handleModal}
          listaFuncionalidades={this.getListaFunctionalities()}
        />

        <div
          style={{
            width: "100%", display: "flex", justifyContent: "center",
          }}
        >
          <div className="col-12 zero" >
            {this.props.isLoadingRoles && <LoadingOverlay />}
            <TablaRoles
              openModal={this.handleModal}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoadingRoles: state.mantenedores.isLoadingRoles,
  roles: state.mantenedores.roles,
  perfiles: state.mantenedores.perfiles,
  functionalities: state.mantenedores.functionalities,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
